// Keep this method so that d3-drag will work, otherwise need to get d3-force simulation to work with React independently.

import { keyBy, flatten } from 'lodash';
import { select } from 'd3-selection';
import { makeTree, getBuildLinePath, buildCrosslink } from '../../utils/tree';


const getCrossLinks = (nodeList) => {
  const nodeMap = keyBy(nodeList, "data.name");
  const makeCrossLinks = d => {
    const neighbors = d.data.crosslinks;
    const start = d;
    return neighbors.split("|").map(neighbor => {
      const end = nodeMap[neighbor];
      return [start, end];
    });
  };

  const nodesWithCrossLink = nodeList.filter(d => d.data.crosslinks);
  return flatten(nodesWithCrossLink.map(makeCrossLinks));
}

// Temporary hack to deal with the fact that x and y are reversed and it confuses the x events
// Same as in tree, except the x/y accessors are flipped
export const buildLinePathStraightForce = d => `
        M${d.target.x},${d.target.y}
        L${d.source.x},${d.source.y}
      `;
export const buildCrosslinkForce = pair => {
  const [start, end] = pair;
  if (pair.some(item => item === undefined)) {
    return ''
  }
  return `
        M${start.x},${start.y}
        L${end.x},${end.y}
      `;
};

export const render = (anchor, hierarchyData, width) => {
  const root = makeTree(hierarchyData, width);
  const svg = select(anchor);


  svg.select('.treeViz').remove(); // prevent overdrawing
  const nodeList = root.descendants().reverse();
  const g = svg
    .append("g")
    .classed('treeViz', true);

  const yOffset = root.dy / 3;
  const buildLinePath = getBuildLinePath(yOffset);
  const crossLinks = getCrossLinks(nodeList);

  const link = g
    .append("g")
    .classed('linkGroup', true)
    .selectAll("path")
    .data(root.links());
  const crossLink = g
    .append("g")
    .classed('crossLinkGroup', true)
    .selectAll("path")
    .data(crossLinks);

  const nodeGroup = g
    .append("g")
    .classed("nodeGroup", true)
    .selectAll("g")
    .data(nodeList);

  // Bind data to the DOM
  const linkPaths = link.enter()
    .append("path")
    .attr("d", buildLinePath);

  const crossLinkPaths = crossLink.enter()
    .append("path")
    .attr("d", buildCrosslink);

  const node = nodeGroup.enter()
    .append("g")
    .classed("clickableNode", d => d.data.url !== undefined)
    .attr("transform", d => `translate(${d.y},${d.x})`)
    .on("click", d => {
      if (d.data.url) {
        window.open(`${d.data.url}`, "_blank");
      }
    });

  // Tick handlers
  node
    .append("circle")
    .attr("fill", d => {
      if (d.data.url) {
        return "#669EFF";
      }
      return d.children ? "#555" : "#999";
    })
    .attr("r", 3);

  node
    .append("text")
    .attr("dy", "0.31em")
    .attr("x", d => d.children ? -6 : 6) // leaf nodes go to the right.
    .text(d => d.data.name)
    .filter(d => d.children)
    .attr("text-anchor", 'end');
}

export default {
  render
}
